import React from 'react'
import UserModuleList from './UserModuleList'

// FEED RECEIVES AN OBJECT OF ALL LICENSED MODULES FROM UserModule.js
// THEN RETURNS EACH INDIVIDUAL MODULE TO UserModuleList.js 

const UserModuleFeed = ({ modules, isInitialUser }) => {
   // The modules list contain module_id, module_name ordered by name ASC
   // for the selected user

   return (
      <div style={{ display: 'flex', justifyContent: 'center' }}>
         <table style={{ border: 'none', width: 'fit-content' }}>
            <tbody>
               <tr>
                  <th style={{ minWidth: '160px', textAlign: 'left', paddingRight: '2rem' }}>Module Name</th>
                  <th id='grant_mod' style={{ width: '80px' }}>Grant Access</th>
               </tr>
               {modules.map(module =>
                  <UserModuleList key={module[0]} module={module} isInitialUser={isInitialUser} />
               )}
            </tbody>
         </table>
      </div>
   )
}

export default UserModuleFeed
